var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page"}},[_c('el-carousel',{attrs:{"height":"545px","interval":5000}},_vm._l((_vm.banner),function(item){return _c('el-carousel-item',{key:item.bannerId},[_c('img',{staticClass:"kcbao_img",attrs:{"src":item.imagePath},on:{"click":function($event){return _vm.bannerdetail(item.chainedAddress)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }